module.exports = __webpack_public_path__ + "img/wallet_04_download.9b65d8eb.png";